import { useEventCallback } from '@spazious/react-hooks';

import { FSetupFetchActionType } from '../types/index.js';

import { useStore } from './useStore.js';

export const useFetchMethodResolver = () => {
  const fetchMethod = useStore(({ fetchMethod }) => fetchMethod);

  const fetchMethodResolver = useEventCallback((id: number, type: FSetupFetchActionType) =>
    fetchMethod(type, id)
  );

  return fetchMethodResolver;
};
